<script setup>
// Voto de entrada de uma enquete (encaminhado pelo ByCall como
// "🗳️ Fulano votou: Opção" ou "🗳️ Fulano retirou o voto na enquete").
// Renderiza de forma compacta — a contagem em si aparece no widget da enquete (Poll.vue).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMessageContext } from '../provider.js';
import BaseBubble from 'next/message/bubbles/Base.vue';

const { t } = useI18n();
const { content } = useMessageContext();

const info = computed(() => {
  const raw = String(content?.value || '').replace(/^🗳️\s*/, '');
  const m = raw.match(/^(.+?)\s+votou:\s*(.+)$/i);
  if (m) return { voter: m[1].trim(), choice: m[2].trim(), retracted: false };
  const r = raw.match(/^(.+?)\s+retirou o voto/i);
  if (r) return { voter: r[1].trim(), choice: '', retracted: true };
  return { voter: '', choice: raw.trim(), retracted: false };
});
</script>

<template>
  <BaseBubble class="!py-1.5 !px-2.5" data-bubble-name="poll-vote" hide-meta>
    <div class="flex items-center gap-1.5 text-sm text-n-slate-11">
      <span
        class="i-ph-check-square-offset-bold size-3.5 shrink-0 text-n-slate-10"
      />
      <span>
        <span class="font-medium text-n-slate-12">{{ info.voter }}</span>
        <template v-if="info.retracted">
          {{ t('CONVERSATION.POLL_BUBBLE.RETRACTED') }}</template
        >
        <template v-else>
          {{ t('CONVERSATION.POLL_BUBBLE.VOTED') }}
          <span class="font-medium text-n-slate-12">{{ info.choice }}</span>
        </template>
      </span>
    </div>
  </BaseBubble>
</template>
